import { useIntl } from 'react-intl';

import { Button } from '@calm-web/design-system';

import { DiscountLandingProps } from '@/components/discountLanding/DiscountLandingWrapper/types';
import GridWrapper from '@/components/ui/GridWrapper';

import { investStats } from './data';
import messages from './messages';
import {
	ButtonWrapper,
	Disclaimer,
	Heading,
	Stat,
	StatDescription,
	StatHeading,
	StatNumber,
	Stats,
	StatsGrid,
	Subheading,
	Wrapper,
} from './styles';

const Invest = ({ onClick }: DiscountLandingProps) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper>
			<GridWrapper columns={3}>
				<Heading>{formatMessage(messages.heading)}</Heading>
				<Subheading>{formatMessage(messages.subheading)}</Subheading>
				{investStats.length > 0 && (
					<Stats>
						<StatsGrid allowOverflow columns={3}>
							{investStats.map(stat => {
								return (
									<Stat key={formatMessage(stat.heading)}>
										<StatHeading>{formatMessage(stat.heading)}</StatHeading>
										<StatNumber>{formatMessage(stat.number)}</StatNumber>
										<StatDescription>{formatMessage(stat.description)}</StatDescription>
									</Stat>
								);
							})}
						</StatsGrid>
					</Stats>
				)}
				<Disclaimer>{formatMessage(messages.disclaimer)}</Disclaimer>
				<ButtonWrapper>
					<Button
						fullWidth
						onPress={() =>
							onClick({
								section: 'invest',
								copy: messages.cta.defaultMessage,
							})
						}
						backgroundColor="gradientCalmBrand"
						textColor="white"
					>
						{formatMessage(messages.cta)}
					</Button>
				</ButtonWrapper>
			</GridWrapper>
		</Wrapper>
	);
};

export default Invest;
